import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import produce from 'immer';
import set from 'lodash/set';
import { getNoticeList, getNoticeView } from 'app/api';

const NOTICE_INIT = 'board/NOTICE_INIT';
export const noticeInit = createAction(NOTICE_INIT);

const NOTICE_GET_DATA = 'board/GET_NOTICE';
export const noticeGetData = createAction(NOTICE_GET_DATA, getNoticeList);

const NOTICEVIEW_INIT = 'board/NOTICEVIEW_INIT';
export const noticeViewInit = createAction(NOTICEVIEW_INIT);

const NOTICEVIEW_GET_DATA = 'board/NOTICEVIEW_GET_DATA';
export const noticeViewGetData = createAction(NOTICEVIEW_GET_DATA, getNoticeView);

const initialState = {
	noticeList: {
		isInit: false,
		isNone: false,
		listData: [],
		totalCount: 0,
	},
	noticeView: {
		isInit: false,
		viewData: {},
	},
};

export default handleActions(
	{
		[NOTICE_INIT]: (state, action) =>
			produce(state, (draft) => {
				set(draft, ['boardList', 'isInit'], action.payload);
			}),

		[NOTICEVIEW_INIT]: (state, action) =>
			produce(state, (draft) => {
				set(draft, ['boardView', 'isInit'], action.payload);
			}),

		...pender({
			type: NOTICE_GET_DATA,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const { notice, totalCount } = data;
					set(draft, ['noticeList', 'listData'], notice);
					set(draft, ['noticeList', 'isNone'], notice.length === 0);
					set(draft, ['noticeList', 'totalCount'], totalCount);
				}),
		}),

		...pender({
			type: NOTICEVIEW_GET_DATA,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, ['noticeView', 'viewData'], data);
				}),
		}),
	},
	initialState,
);
